import {FC, ReactNode} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, WithChildren} from '../../../helpers'
import {AsideMenuIcon} from './AsideMenuIcon'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  /** Счётчик справа от названия (см. .menu-badge в Metronic) — напр. непрочитанные/новые. */
  badge?: ReactNode
  /** «Скоро» — пункт виден, но не кликабелен (см. AsideMenuMain.tsx, comingSoon). */
  disabled?: boolean
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  badge,
  disabled = false,
}) => {
  const {pathname} = useLocation()
  const isActive = !disabled && checkIsActive(pathname, to)

  const content = (
    <>
      {hasBullet && (
        <span className='menu-bullet'>
          <span className='bullet bullet-dot'></span>
        </span>
      )}
      {icon && (
        <span className='menu-icon'>
          <AsideMenuIcon name={icon} />
        </span>
      )}
      {fontIcon && <i className={clsx('bi fs-3', fontIcon)}></i>}
      <span className='menu-title'>{title}</span>
      {badge && <span className='menu-badge'>{badge}</span>}
    </>
  )

  return (
    <div className='menu-item'>
      {disabled ? (
        <span className='menu-link without-sub opacity-50' style={{cursor: 'default'}}>
          {content}
        </span>
      ) : (
        <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
          {content}
        </Link>
      )}
      {children}
    </div>
  )
}

export {AsideMenuItem}
